import { render, staticRenderFns } from "./RelativePrint.vue?vue&type=template&id=bcd7a126&scoped=true"
import script from "./RelativePrint.vue?vue&type=script&lang=js"
export * from "./RelativePrint.vue?vue&type=script&lang=js"
import style0 from "./RelativePrint.vue?vue&type=style&index=0&id=bcd7a126&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcd7a126",
  null
  
)

export default component.exports